module.exports = __webpack_public_path__ + "assets/images/76d344f08412543c74ccd1fb2493d607.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/github.svg
// module id = 726
// module chunks = 0